export const JSDataTypes = Object.freeze({
  /** Функция
   *  @type {string} */
  Function: 'function'
})